export default class Auth {
    constructor() {
        this.url = sessionStorage.getItem('kiplan_api_url');
        if (!this.url) {
            this.url = window.location.origin + '/api';
            sessionStorage.setItem('kiplan_api_url', this.url);
        }
    }

    // ── helpers ───────────────────────────────────────────────────

    _decode(token) {
        try {
            return JSON.parse(atob(token.split('.')[1]));
        } catch {
            return null;
        }
    }

    _baseHeaders(extra = {}) {
        const headers = { 'Content-Type': 'application/json', ...extra };
        const token = this.getToken();
        if (token) headers['Authorization'] = `Bearer ${token}`;
        return headers;
    }

    _handleResponse(response) {
        const newToken = response.headers.get('X-New-Token');
        if (newToken) {
            // sessionStorage.setItem('token', newToken);
        }
        if (response.status === 401) {
            this.redirectToLogin();
        }
        if (response.status === 429) {
            console.warn(`Rate limited. Retry in ${response.headers.get('Retry-After')}s`);
        }
    }

    getToken() {
        return sessionStorage.getItem('token');
    }

    // ── auth ──────────────────────────────────────────────────────

    async login(username, password) {
        const response = await fetch(`${this.url}/login`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ username, pwd: password }),
            credentials: 'include',
        });
        if (response.status === 200) {
            const token = await response.json();
            sessionStorage.setItem('token', token);
            return token;
        } else {
            throw new Error(await response.text());
        }
    }

    async whoami() {
        try {
            const response = await fetch(`${this.url}/whoami`, {
                method: 'GET',
                headers: this._baseHeaders(),
                credentials: 'include',
            });
            this._handleResponse(response);
            if (!response.headers.get('Content-Type')?.includes('application/json')) this.redirectToLogin();
            if (response.status === 200) return await response.json();
        } catch (error) {
            console.log(error);
        }
        return false;
    }

    // ── requests ──────────────────────────────────────────────────

    async fetch(url, options) {
        if (!url.startsWith('/')) url = '/' + url;

        const response = await fetch(`${this.url}${url}`, {
            method: 'GET',
            ...options,
            headers: this._baseHeaders(options?.headers),
            credentials: 'include',
        });

        this._handleResponse(response);
        return response;
    }

    // ── helpdesk (login con Kiplan en helpdesk.kiplan.io) ─────────

    async helpdeskConfig() {
        const response = await this.fetch('/helpdesk/config');
        if (response.status !== 200) return { enabled: false, url: null };
        return await response.json();
    }

    async helpdeskAssertion(state) {
        const response = await this.fetch('/helpdesk/assertion', {
            method: 'POST',
            body: JSON.stringify({ state }),
        });
        if (response.status !== 200) throw new Error(`helpdesk assertion ${response.status}`);
        return await response.json();
    }

    async uploadFile(url, options) {
        if (!url.startsWith('/')) url = '/' + url;

        const headers = {};
        const token = this.getToken();
        if (token) headers['Authorization'] = `Bearer ${token}`;

        const response = await fetch(`${this.url}${url}`, {
            method: 'POST',
            headers,
            ...options,
            credentials: 'include',
        });

        this._handleResponse(response);
        return response;
    }

    async query(query) {
        const response = await this.fetch(`/cube/v1/query/${query.model_id}`, {
            method: 'POST',
            body: JSON.stringify({ query }),
        });
        return await response.json();
    }

    async launchProcess(processId, params) {
        const response = await this.fetch(`/process/execute_sync/${processId}`, {
            method: 'POST',
            body: JSON.stringify({ parameters: params }),
        });
        if (response.status === 200) {
            return await response.json();
        } else {
            const error_json = await response.json();
            throw new Error(`Error launching process:\n ${error_json.detail}`);
        }
    }

    // ── navigation ────────────────────────────────────────────────

    redirectToLogin() {
        if (!top.window.location.href.includes('/accounts/')) {
            const pathWithQuery = window.location.pathname + window.location.search;
            window.location.href = `/accounts/login?next=${encodeURIComponent(pathWithQuery)}`;
        }
    }
}